import type { CSSProperties } from "react";
import { cn } from "../cn";

/**
 * Canonical PlayerDNA wordmark — "Player" in a green→blue gradient, "DNA" in ink.
 * Inline-styled with brand hex so it renders identically across every app
 * (deck, marketing, pwa) regardless of their Tailwind setup. Pass `className`
 * to control font family / size (e.g. "font-display text-lg").
 */
const PLAYER: CSSProperties = {
  backgroundImage: "linear-gradient(90deg, #20E070 0%, #20E070 55%, #38BDF8 100%)",
  WebkitBackgroundClip: "text",
  backgroundClip: "text",
  WebkitTextFillColor: "transparent",
  color: "transparent",
};

export function Wordmark({ className }: { className?: string }) {
  return (
    <span className={cn("font-extrabold tracking-tight", className)}>
      <span style={PLAYER}>Player</span>
      <span style={{ color: "#F8FAFC" }}>DNA</span>
    </span>
  );
}
